import cancel from "../assets/images/navbar/cancel.png";
import phonepe from "../assets/images/payment/phonepe.png";
import gpay from "../assets/images/payment/gpay.png";
import bank from "../assets/images/payment/bank.png";
import upi from "../assets/images/payment/upi.png";
import visa from "../assets/images/payment/visa.png";
import cod from "../assets/images/payment/cod.png";

interface PaymentModeProps {
  onClose: () => void;
}

const PaymentMode = ({ onClose }: PaymentModeProps) => {
  return (
    <div>
      {/* Backdrop Overlay */}
      <div
        className="fixed inset-0 bg-black bg-opacity-50 z-[1003]"
        onClick={onClose}
      />

      {/* Modal Container */}
      <div className="fixed inset-0 flex items-center justify-center z-[1004] pointer-events-none">
        <div
          className="w-[545px] p-8 rounded-[24px] bg-white pointer-events-auto relative"
          style={{
            boxShadow: "-23px 23px 72px 0 rgba(0, 0, 0, 0.15)",
          }}
          onClick={(e) => e.stopPropagation()}
        >
          {/* Close Button */}
          <div
            className="absolute top-6 right-6 h-[36px] w-[36px] cursor-pointer border rounded-full p-[7px] bg-white flex items-center justify-center"
            onClick={onClose}
          >
            <img src={cancel} alt="Close" className="h-[18px] w-[18px]" />
          </div>

          {/* Logo */}
          <div className="mb-[36px]">
            <p>Select Payment Method</p>
          </div>
          {/* main section  */}
          <div className="border-2 p-[12px] rounded-[16px]">
            <div className="flex justify-between items-center pb-[12px] border-b-2">
              <div className="flex justify-center items-center gap-[10px]">
                <div className="flex justify-center items-center h-[48px] w-[48px] rounded-[16px] border-2">
                  <img
                    src={phonepe}
                    alt="phonepe"
                    className="h-[27px] w-[27px]"
                  />
                </div>
                <div>
                  <h6 className="text-[#050505] text-center font-Urbanist text-[16px] font-medium leading-[160%]">
                    Abhishek@phonepe
                  </h6>
                  <p className="text-[#6A6A6A] font-Urbanist text-[14px] font-normal leading-[140%]">
                    Phonepe
                  </p>{" "}
                </div>
              </div>

              <div>
                <input type="radio" name="payment" id="phonepe" className="" />
              </div>
            </div>
            <div className="flex justify-between items-center pt-[12px]">
              <div className="flex justify-center items-center gap-[10px]">
                <div className="flex justify-center items-center h-[48px] w-[48px] rounded-[16px] border-2">
                  <img src={gpay} alt="gpay" className="h-[27px] w-[27px]" />
                </div>
                <div>
                  <h6 className="text-[#050505] text-center font-Urbanist text-[16px] font-medium leading-[160%]">
                    Abhishek@icici
                  </h6>
                  <p className="text-[#6A6A6A] font-Urbanist text-[14px] font-normal leading-[140%]">
                    Google Pay
                  </p>{" "}
                </div>
              </div>

              <div>
                <input type="radio" name="payment" id="phonepe" className="" />
              </div>
            </div>
          </div>

          <div className="border-2 p-[12px] rounded-[16px] my-[24px]">
            <div className="flex justify-between items-center pb-[12px] border-b-2">
              <div className="flex justify-center items-center gap-[10px]">
                <div className="flex justify-center items-center h-[48px] w-[48px] rounded-[16px] border-2">
                  <img src={upi} alt="upi" className="h-[27px] w-[27px]" />
                </div>
                <div>
                  <h6 className="text-[#050505] font-Urbanist text-[16px] font-medium leading-[160%]">
                    UPI
                  </h6>
                  <p className="text-[#6A6A6A] font-Urbanist text-[14px] font-normal leading-[140%]">
                    Add your UPI ID
                  </p>{" "}
                </div>
              </div>

              <div>
                <input type="radio" name="payment" id="phonepe" className="" />
              </div>
            </div>
            <div className="flex justify-between items-center pt-[12px] pb-[12px] border-b-2">
              <div className="flex justify-center items-center gap-[10px]">
                <div className="flex justify-center items-center h-[48px] w-[48px] rounded-[16px] border-2">
                  <img src={visa} alt="visa" className="h-[27px] w-[27px]" />
                </div>
                <div>
                  <h6 className="text-[#050505] font-Urbanist text-[16px] font-medium leading-[160%]">
                    Card
                  </h6>
                  <p className="text-[#6A6A6A] font-Urbanist text-[14px] font-normal leading-[140%]">
                    Debit or Credit card
                  </p>{" "}
                </div>
              </div>

              <div>
                <input type="radio" name="payment" id="phonepe" className="" />
              </div>
            </div>
            <div className="flex justify-between items-center py-[12px] border-b-2">
              <div className="flex justify-center items-center gap-[10px]">
                <div className="flex justify-center items-center h-[48px] w-[48px] rounded-[16px] border-2">
                  <img src={bank} alt="bank" className="h-[27px] w-[27px]" />
                </div>
                <div>
                  <h6 className="text-[#050505] font-Urbanist text-[16px] font-medium leading-[160%]">
                    Internet banking
                  </h6>
                  <p className="text-[#6A6A6A] font-Urbanist text-[14px] font-normal leading-[140%]">
                    Pay directly with your bank
                  </p>{" "}
                </div>
              </div>

              <div>
                <input type="radio" name="payment" id="phonepe" className="" />
              </div>
            </div>
            <div className="flex justify-between items-center pt-[12px]">
              <div className="flex justify-center items-center gap-[10px]">
                <div className="flex justify-center items-center h-[48px] w-[48px] rounded-[16px] border-2">
                  <img src={cod} alt="gpay" className="h-[27px] w-[27px]" />
                </div>
                <div>
                  <h6 className="text-[#050505] font-Urbanist text-[16px] font-medium leading-[160%]">
                    Cash on Delivery
                  </h6>
                  <p className="text-[#6A6A6A] font-Urbanist text-[14px] font-normal leading-[140%]">
                    Pay directly to delivery partner
                  </p>{" "}
                </div>
              </div>

              <div>
                <input type="radio" name="payment" id="phonepe" className="" />
              </div>
            </div>
          </div>

          {/* Verify Button */}
          <button className="w-full flex items-center justify-between py-4 px-6 bg-[#FF8A00] rounded-[150px] cursor-pointer hover:bg-[#5f0289] transition-colors">
            <span className="w-full text-white text-center font-Urbanist text-[20px] font-semibold leading-[140%]">
              Pay ₹42,000
            </span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentMode;
